import styled from "styled-components";

const _color = "#F0F7FF";

function responsiveRadius(size) {
  return `
        .right {
            border-top-left-radius: ${size}px;
        }
        .left {
            border-top-right-radius: ${size}px;
        }
    `;
}

export const MenuContainer = styled.div`
  position: fixed;

  width: 100%;
  z-index: 1000;
  bottom: 0;
  padding: 16px 24px;
  /* padding-bottom: 1.5rem; */
  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 6rem;
    padding: 0.3rem;
    & > div {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      & > a {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
        }
        span {
          color: #27548c;
          font-size: 12px;
          font-weight: 400;
          &.active {
            font-weight: 700;
          }
        }
      }
    }
    .left {
      border-top-left-radius: 30px;
      border-bottom-left-radius: 30px;
      border-top-right-radius: 30px;
      box-shadow: 0px 0px 15px #f0f7ff;
      flex: 1 1 auto;
      background-color: ${_color};
    }
    .mid {
      height: 80%;
      margin-top: auto;
      width: 12rem;
      background-image: radial-gradient(
        circle 50px at top center,
        transparent 99%,
        #f0f7ff 0
      );
      padding: 0 10px;
      position: relative;
      & span {
        font-size: 12px;
        font-weight: 400;
        display: inline-flex;
        margin-top: 30%;
      }
      .circle {
        position: absolute;
        background-color: #27548c;
        top: -65%;
        border-radius: 50%;
        height: 85px;
        width: 85px;
        color: #fff;
        margin-right: auto;
        margin-left: auto;
        text-align: center;
        left: 0;
        right: 0;
        img {
          width: 50px;
          height: 50px;
          margin-top: 1rem;
        }
      }
    }
    .right {
      flex: 1 1 auto;
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      border-top-left-radius: 30px;
      background-color: ${_color};
      box-shadow: 0px 0px 15px #f0f7ff;
    }
    @media (max-width: 984px) {
      ${responsiveRadius(34)}
    }
    @media (max-width: 808px) {
      ${responsiveRadius(39)}
    }
    @media (max-width: 660px) {
      ${responsiveRadius(43)}
    }
    @media (max-width: 660px) {
      ${responsiveRadius(30)}
      .mid {
        width: 11rem;
        height: 97%;
        .circle {
          top: -39%;
          height: 72px;
          width: 72px;
          img {
            height: 44px;
            width: 44px;
            padding-bottom: 0.18rem;
          }
        }
      }
    }
    @media (max-width: 560px) {
      ${responsiveRadius(33)}
    }
    @media (max-width: 478px) {
      ${responsiveRadius(36)}
    }
    @media (max-width: 478px) {
      ${responsiveRadius(40)}
      .mid {
        width: 9rem;
        height: 100%;
        .circle {
          top: -39%;
          height: 72px;
          width: 72px;
          img {
            height: 44px;
            width: 44px;
            padding-bottom: 0.18rem;
          }
        }
      }
    }
  }
`;
